import { CommandName } from '../CommandViewModel';

import CategoryCommandImpl from './CategoryCommandImpl';

class NoopCommandImpl extends CategoryCommandImpl<void> {
  public async execute(): Promise<void> {
    // not implemented
  }

  public async getInitialArgs(): Promise<void> {
    // not implemented
  }

  public getName(): CommandName {
    return 'unknown';
  }
}

export default NoopCommandImpl;
